
export default {
  props: {
    text: {
      type: String,
      default: 'View more'
    },
    link: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick(e) {
      if (!this.link) {
        e.preventDefault()
      }
      this.$emit('btn-click')
    }
  }
}
